module.exports = function() {
  return new Worker(__webpack_public_path__ + "3e3ad1a05b5eda62fd23.worker.js");
};